<template>
    <v-container fill-height>
        <v-row justify="center">
            <v-col xs="10" sm="6" md="4">
                <div  class="pa-4 white lighten-4 elevation-6">
                    <div class="d-flex justify-center"><img src="../../assets/Logo ITP.svg" class="pb-5" width="200px"></div>
                    <v-text-field color="black" class="mt-6" prepend-inner-icon="mdi-account " v-model="usuario" :rules="[rules.required]" dense outlined label="Correo" autofocus></v-text-field>
                    <br>
                    <v-text-field color="black" prepend-inner-icon="mdi-key" v-model="contraseña" @keypress.enter="autenticar" :rules="[rules.required]" dense outlined label="Contraseña" type ='password'></v-text-field>
                    <br>
                    <v-btn @click="autenticar" color="primary" dark width="100%">Entrar</v-btn>                          
                </div>
            </v-col>
        </v-row>        
        <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" dark>
            <div class="d-flex justify-center"><b>{{snackbar_msj}}</b></div>
        </v-snackbar>

    </v-container>
</template>

<script>
export default {
    data() {
        return {
            usuario: '',
            contraseña: '',
            snackbar: false,
            snackbar_timeout: 3000,
            snackbar_color: "",
            snackbar_msj: "",
            rules:{
                required: value => !!value || 'Requerido'
            }
        }
    },
    methods: {
        autenticar: function(){

            if(this.usuario && this.contraseña){
                this.axios.post(this.$url+'/acceso/validacion/usuario', {correo: this.usuario, contraseña: this.contraseña})
                .then((response)=>{
                    let rs = response.data

                    if(!rs.error){
                        if(rs.auth){                            
                            sessionStorage.setItem('datax', rs.token)
                            //Redirigir
                            this.snackbar_msj = "Acceso correcto"
                            this.snackbar_color = "success"
                            this.limpiar_campos(),
                            this.snackbar = true; 

                            this.$router.push({name:'PanelAdministrativo'})
                            

                        }
                        else{
                            this.snackbar_msj = rs.mensaje
                            this.snackbar_color = "error"
                            this.limpiar_campos(),
                            this.snackbar = true; 
                        }
                    }
                    else{
                        this.snackbar_msj = rs.mensaje
                        this.snackbar_color = "error"
                        this.limpiar_campos(),
                        this.snackbar = true; 
                    }                   

                })
                .catch((error)=>{
                    console.log(error);
                    this.snackbar_msj = "Error en la conexión."
                    this.snackbar_color = "error"
                    this.snackbar = true; 
                })
            }
            else{
                this.snackbar_msj = "Todos los datos son requeridos."
                this.snackbar_color = "error"
                this.snackbar = true; 
            }           
           
            
        },
        
        limpiar_campos: function(){
            this.usuario = "";
            this.contraseña = "";
        } 
    
    },
}
</script>

<style lang="">

</style>